import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { INAAction } from '../../model/ina-action';
import { LstQuestionValueDataView, Section } from '../model/inaSchoolEnrollments';
import { Shared } from '../../service/shared';
import { InaService } from '../../service/ina.service';
import { StepAction } from '../model/stepAction';
import { TrackingHistories, TrackingHistory } from '../../service/history';

@Component({
  selector: 'app-health-information',
  templateUrl: './health-information.component.html',
  styleUrls: ['./health-information.component.scss']
})


export class HealthInformationComponent implements OnInit {
  @Input('step') step: number;
  @Input('action') action: INAAction;

  @Output() prevOrNextStep = new EventEmitter<StepAction>();
  @Output() valid = new EventEmitter<boolean>();
  @Output() updateHistory = new EventEmitter<TrackingHistory>();
  //@Output() emitValidation=new EventEmitter<ValidationErrors>();


  frmHealthInformation: UntypedFormGroup;
  section: Section;
  shared: Shared;
  notifyAction: string = '';
  inaStatusTypeId: number;
  lstTrackHistory: TrackingHistory[] = [];
  trackHistories: TrackingHistories = new TrackingHistories();

  constructor(
    private fb: UntypedFormBuilder, 
    private inaService: InaService
  ) {
    this.shared = new Shared(inaService);
    this.trackHistories.inaHistory = [];
    this.frmHealthInformation = this.fb.group({
      radioHealthInsurance: [],
      mediCal: [],
      radioHealConcern: [],
      currentlyTreatment: [],

      medical: [],
      dental: [],
      vision: [],
      mentalHealth: [],
      chkHealthOther: [],

      txtHealthOther: [],
      healthNone: [],
      food: [],
      housing: [],
      clothing: [],
      chkEmergencyOther: [],
      txtEmergencyOther: []
    });



  }

  ngAfterViewInit(): void {
    this.fireValidation();

  }
  fireValidation() {
    if (this.action != INAAction.View) {
      if (this.medical.value == true ||
        this.dental.value == true ||
        this.vision.value == true ||
        this.mentalHealth.value == true ||
        this.chkHealthOther.value == true ||
        this.healthNone.value == true) {
        this.frmHealthInformation.setErrors(null);
      }
      else {
        this.frmHealthInformation.setErrors({ required: true, invalid: 'Select Health Needs' });
      }
      let validator: boolean = (this.frmHealthInformation.errors?.['required'] == true) ? false : true;
      this.valid.emit(validator);
    }
  }

  ngOnInit(): void {
    let sectionId: number = 26;
    if (this.action == INAAction.View)
      this.frmHealthInformation.disable();
    else {
      this.changeDetection();
      this.frmHealthInformation.valueChanges.subscribe(() => {
        this.updateChangeValue();
      });

    }

    this.inaService.inaSelectionSubject$.subscribe(x => {
      this.section = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == sectionId)!;
      this.inaStatusTypeId = x.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId;

    });
    this.inaService.inaHistorySelectionSubject$.subscribe((x: TrackingHistories) => {
      if (x.inaHistory?.length >= 1) {
        this.trackHistories.inaHistory = x.inaHistory.filter(x => x.ChangedField.split(',')[0] == sectionId.toString());
      }

    });
    setTimeout(() => {
      this.frmHealthInformation.reset();
      this.setFormValue()
      if (this.action == INAAction.View)
      {
        this.frmHealthInformation.disable();
      }
    }, 1000);


  }

  setFormValue() {
    this.getListQuestionValueData(448, 'Health Insurance?')?.forEach(
      x => {
        if (x.Name == 'Yes' && x.Value == 'True') {
          this.radioHealthInsurance.setValue("1");
          this.mediCal.enable();
        }
        else if (x.Name == 'No' && x.Value == 'True') {
          this.radioHealthInsurance.setValue("2");
          this.mediCal.disable();
        }
        else if (x.Name == 'Medi-Cal' && x.Value == 'True')
          this.mediCal.setValue(true);
        else if (x.Name == 'Medi-Cal' && x.Value == 'False')
          this.mediCal.setValue(false);
      }
    );
    this.getListQuestionValueData(452, 'Health Concerns?').forEach(
      x => {
        if (x.Name == 'Yes' && x.Value == 'True') {
          this.radioHealConcern.setValue("1");
          this.currentlyTreatment.enable();
        }
        else if (x.Name == 'No' && x.Value == 'True') {
          this.radioHealConcern.setValue("2");
          this.currentlyTreatment.disable();
        }
        else if (x.Name == 'Currently in treatment' && x.Value == 'True')
          this.currentlyTreatment.setValue(true);
        else if (x.Name == 'Currently in treatment' && x.Value == 'False')
          this.currentlyTreatment.setValue(false);
      }
    );

    this.getListQuestionValueData(456, 'Health Needs').forEach(
      x => {
        if (x.Name == 'Medical') {
          if (x.Value == 'True')
            this.medical.setValue(true);
          else
            this.medical.setValue(false);
        }
        else if (x.Name == 'Dental') {
          if (x.Value == 'True')
            this.dental.setValue(true);
          else
            this.dental.setValue(false);
        }
        else if (x.Name == 'Vision') {
          if (x.Value == 'True')
            this.vision.setValue(true);
          else
            this.vision.setValue(false);
        }
        else if (x.Name == 'Mental Health') {
          if (x.Value == 'True')
            this.mentalHealth.setValue(true);
          else
            this.mentalHealth.setValue(false);
        }
        else if (x.Name == 'Other') {
          if (x.Value == 'True')
            this.chkHealthOther.setValue(true);
          else {
            this.chkHealthOther.setValue(false);
            this.txtHealthOther.disable();
          }
        }
        else if (x.Name == 'Comments') {
          if (this.chkHealthOther.value == true)
            this.txtHealthOther.setValue(x.Value);
          else {
            this.chkHealthOther.setValue(false);
            this.txtHealthOther.disable();
          }
        }
        else if (x.Name == 'None') {
          if (x.Value == 'True')
            this.healthNone.setValue(true);
          else
            this.healthNone.setValue(false);
        }
      }
    );

    this.getListQuestionValueData(464, 'Emergency Services').forEach(
      x => {
        if (x.Name == 'Food') {
          if (x.Value == 'True')
            this.food.setValue(true);
          else
            this.food.setValue(false);
        }
        else if (x.Name == 'Housing') {
          if (x.Value == 'True')
            this.housing.setValue(true);
          else
            this.housing.setValue(false);
        }
        else if (x.Name == 'Clothing') {
          if (x.Value == 'True')
            this.clothing.setValue(true);
          else
            this.clothing.setValue(false);
        }
        else if (x.Name == 'Other') {
          if (x.Value == 'True')
            this.chkEmergencyOther.setValue(true);
          else {
            this.chkEmergencyOther.setValue(false);
            this.txtEmergencyOther.disable();
          }
        }
        else if (x.Name == 'Comments')
          this.txtEmergencyOther.setValue(x.Value);
        /*else if(x.Name=='None')
          console.log('Need to address this issue')*/
      }
    )
    this.fireValidation();
  }
  changeDetection() {
    this.radioHealthInsurance.valueChanges.subscribe((x: any) => {
      if (x == 1)
        this.mediCal.enable();
      else {
        this.mediCal.setValue('');
        this.mediCal.disable();
      }
    });
    this.radioHealConcern.valueChanges.subscribe((x: any) => {
      if (x == 1)
        this.currentlyTreatment.enable();
      else {
        this.currentlyTreatment.setValue('');
        this.currentlyTreatment.disable();
      }
    });
    this.chkHealthOther.valueChanges.subscribe((x: any) => {
      if (x == true) {
        this.txtHealthOther.enable();
      }
      else {
        this.txtHealthOther.setValue('');
        this.txtHealthOther.disable();
      }
    });
    this.chkEmergencyOther.valueChanges.subscribe((x: any) => {
      if (x == true) {
        this.txtEmergencyOther.enable();
      }
      else {
        this.txtEmergencyOther.setValue('');
        this.txtEmergencyOther.disable();
      }
    })

    this.frmHealthInformation.valueChanges.subscribe((valChange: any) => {
      if (valChange.medical == true
        || valChange.dental == true
        || valChange.vision == true
        || valChange.mentalHealth == true
        || valChange.chkHealthOther == true
        || valChange.healthNone == true) {
        this.frmHealthInformation.setErrors(null);

      }
      else {
        this.frmHealthInformation.setErrors({ required: true, invalid: 'Select Health Needs' })

      }
    });


  }

  getListQuestionValueData(questionId: number, questionName: string): LstQuestionValueDataView[] {
    {
      return this.shared.getListQuestionValueData(this.section, questionId, questionName);
    }

  }

  getQuestionValue(questionId: number, questionName: string): string {
    return this.shared.getQuestionValue(this.section, questionId, questionName);
  }

  /*
  setStep(index: number) {
    this.step = index;
    let s: StepAction = new StepAction();
    s.stepNumber = this.step;
    this.prevOrNextStep.emit(s);
  }
  nextStep() {
    this.notifyAction = 'Next';
    this.notifyChanges(0);
  }

  prevStep() {
    this.notifyAction = 'Prev';
    this.notifyChanges(0);
  }

  notifyChanges(action: number) {
    let s: StepAction = new StepAction();
    s.stepNumber = 9;
    s.action = action == 1 ? '' : this.notifyAction;
    s.section = new Section();
    if (this.frmHealthInformation.dirty) {
      this.updateChangeValue();
      s.section = this.section;
      s.lsttrackingHistory = this.lstTrackHistory;
      this.lstTrackHistory = [];
    }
    this.prevOrNextStep.emit(s);
  }
    */

  updateChangeValueLostFocus() {
    if (this.txtHealthOther.dirty) {
      this.setListQuestionValue(456, 'Comments', this.txtHealthOther.value);
      this.txtHealthOther.markAsPristine();
    }

    if (this.txtEmergencyOther.dirty) {
      this.setListQuestionValue(464, 'Comments', this.txtEmergencyOther.value);
      this.txtEmergencyOther.markAsPristine();
    }
    this.fireValidation();
  }
  updateChangeValue() {
    if (this.radioHealthInsurance.dirty) {
      let radioVal: string = '';
      radioVal = this.radioHealthInsurance.value;
      this.setRadioValue(448, 'Yes', radioVal);
      this.radioHealthInsurance.markAsPristine()
    }
    if (this.mediCal.dirty) {
      let radioVal: string = '';
      radioVal = this.mediCal.value == 1 ? "True" : "False";
      this.setListQuestionValue(448, 'Medi-Cal', radioVal);
      this.mediCal.markAsPristine();
    }
    if (this.radioHealConcern.dirty) {
      let radioVal: string = '';
      radioVal = this.radioHealConcern.value;
      this.setRadioValue(452, 'Yes', radioVal);
      this.radioHealConcern.markAsPristine();
    }

    if (this.currentlyTreatment.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.currentlyTreatment.value == 1 ? "True" : "False";
      this.setListQuestionValue(452, 'Currently in treatment', checkBoxVal);
      this.currentlyTreatment.markAsPristine();
    }
    if (this.medical.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.medical.value == 1 ? "True" : "False";
      this.setListQuestionValue(456, 'Medical', checkBoxVal);
      this.medical.markAsPristine();
    }
    if (this.dental.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.dental.value == 1 ? "True" : "False";
      this.setListQuestionValue(456, 'Dental', checkBoxVal);
      this.dental.markAsPristine();
    }
    if (this.vision.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.vision.value == 1 ? "True" : "False";
      this.setListQuestionValue(456, 'Vision', checkBoxVal);
      this.vision.markAsPristine();
    }
    if (this.mentalHealth.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.mentalHealth.value == 1 ? "True" : "False";
      this.setListQuestionValue(456, 'Mental Health', checkBoxVal);
      this.mentalHealth.markAsPristine();
    }
    if (this.chkHealthOther.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkHealthOther.value == 1 ? "True" : "False";
      this.setListQuestionValue(456, 'Other', checkBoxVal);
      this.chkHealthOther.markAsPristine();
      if (checkBoxVal == 'False') {
        this.txtHealthOther.setValue('');
        this.txtHealthOther.markAsDirty();
        this.updateChangeValueLostFocus();
      }
    }
    if (this.healthNone.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.healthNone.value == 1 ? "True" : "False";
      this.setListQuestionValue(456, 'None', checkBoxVal);
      this.healthNone.markAsPristine();
    }
    if (this.food.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.food.value == 1 ? "True" : "False";
      this.setListQuestionValue(464, 'Food', checkBoxVal);
      this.food.markAsPristine();
    }
    if (this.housing.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.housing.value == 1 ? "True" : "False";
      this.setListQuestionValue(464, 'Housing', checkBoxVal);
      this.housing.markAsPristine();
    }
    if (this.clothing.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.clothing.value == 1 ? "True" : "False";
      this.setListQuestionValue(464, 'Clothing', checkBoxVal);
      this.clothing.markAsPristine();
    }
    if (this.chkEmergencyOther.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkEmergencyOther.value == 1 ? "True" : "False";
      this.setListQuestionValue(464, 'Other', checkBoxVal);
      this.chkEmergencyOther.markAsPristine();
      if (checkBoxVal == 'False') {
        this.txtEmergencyOther.setValue('');
        this.txtEmergencyOther.markAsDirty();
        this.updateChangeValueLostFocus();
      }
    }
    this.fireValidation();
  }

  setRadioValue(questionId: number, questionName: string, value: string) {
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setRadioValue(this.section, questionId, value);
    this.fireValidation();
    //this.shared.updateCacheSection(this.section);
  }

  setListQuestionValue(questionId: number, questionName: string, value: string) {
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setListQuestionValue(this.section, questionId, questionName, value);
    this.fireValidation();
    //this.shared.updateCacheSection(this.section);

  }
  setTrackingHistory(questionId: number, questionName: string, value: string) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTrackingHistory(this.section, questionId, questionName, value);
      this.updateHistory.emit(tempTrackingHistory);
    }
  }

  get radioHealthInsurance(): any { return this.frmHealthInformation.get('radioHealthInsurance'); }
  get mediCal(): any { return this.frmHealthInformation.get('mediCal'); }
  get radioHealConcern(): any { return this.frmHealthInformation.get('radioHealConcern'); }
  get currentlyTreatment(): any { return this.frmHealthInformation.get('currentlyTreatment'); }
  get medical(): any { return this.frmHealthInformation.get('medical'); }
  get dental(): any { return this.frmHealthInformation.get('dental'); }
  get vision(): any { return this.frmHealthInformation.get('vision'); }
  get mentalHealth(): any { return this.frmHealthInformation.get('mentalHealth'); }
  get chkHealthOther(): any { return this.frmHealthInformation.get('chkHealthOther'); }
  get txtHealthOther(): any { return this.frmHealthInformation.get('txtHealthOther'); }
  get healthNone(): any { return this.frmHealthInformation.get('healthNone'); }
  get food(): any { return this.frmHealthInformation.get('food'); }
  get housing(): any { return this.frmHealthInformation.get('housing'); }
  get clothing(): any { return this.frmHealthInformation.get('clothing'); }
  get chkEmergencyOther(): any { return this.frmHealthInformation.get('chkEmergencyOther'); }
  get txtEmergencyOther(): any { return this.frmHealthInformation.get('txtEmergencyOther'); }





}
